import { VideoContainerUi } from 'common/components/entities/Video/ui/VideoContainerUi'
import VideoUi from 'common/components/entities/Video/ui/VideoUi'
import { VideoAspectRatio } from 'common/types/entities/VideoInterface'
import React, { useEffect, useRef } from 'react'
import ReactPlayer from 'react-player'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import VideoPlaceholderInner from './ui/VideoPlaceholderInnerUi'
import VideoPlaceholder from './ui/VideoPlaceholderUi'

type BasePlayerProps = BorderEntityInterface & {
  attrId: string
  url: string
  posterUrl?: string
  controls?: boolean
  boxShadow?: string
  mobileBoxShadow?: string
  disabledPointerEvents?: boolean
  aspectRatio?: VideoAspectRatio
}

const BasePlayer = ({
  url,
  controls,
  border,
  mobileBorder,
  boxShadow,
  mobileBoxShadow,
  disabledPointerEvents = false,
  posterUrl,
  aspectRatio,
}: BasePlayerProps) => {
  const video = useRef<ReactPlayer>(null)
  useEffect(() => {
    if (video.current) {
      const player = video.current.getInternalPlayer()
      //The React-player config is memorized, we need to change the poster along with the posterUrl
      if (player) {
        if (posterUrl) {
          player.setAttribute('poster', posterUrl)
        } else {
          player.removeAttribute('poster')
        }
      }
    }
  }, [posterUrl])

  if (!url) {
    return (
      <VideoPlaceholder
        border={border}
        mobileBorder={mobileBorder}
        boxShadow={boxShadow}
        mobileBoxShadow={mobileBoxShadow}
        aspectRatio={aspectRatio}
      >
        <VideoPlaceholderInner />
      </VideoPlaceholder>
    )
  }

  return (
    <VideoContainerUi
      border={border}
      mobileBorder={mobileBorder}
      boxShadow={boxShadow}
      mobileBoxShadow={mobileBoxShadow}
    >
      <VideoUi
        disabledPointerEvents={disabledPointerEvents}
        aspectRatio={aspectRatio}
      >
        <ReactPlayer
          ref={video}
          width="100%"
          height="100%"
          url={url}
          className="react-player"
          controls={controls}
          config={{
            file: {
              attributes: {
                controlsList: 'nodownload',
                poster: posterUrl,
              },
            },
          }}
        />
      </VideoUi>
    </VideoContainerUi>
  )
}

export default BasePlayer
